import { render } from "./style.vue?vue&type=template&id=36bcdbf2&scoped=true"
import script from "./style.vue?vue&type=script&lang=js"
export * from "./style.vue?vue&type=script&lang=js"

import "./style.vue?vue&type=style&index=0&id=36bcdbf2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bcdbf2"]])

export default __exports__